// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__Ay6Lh","customBtn":"Button_customBtn__BZwoB"};